import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import { Typography, Checkbox, Button, Row, Col } from 'antd';

const { Paragraph, Title } = Typography;

const VDFMDocument = ({
  showApproveButton,
  showCheckBox,
  handleCheckBoxChange,
  handleAccept,
}) => {
  return (
    <div style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
      <Title level={4}>
        Παρακαλώ όπως διαβάσετε προσεκτικά τις ακόλουθες πληροφορίες καθώς
        μπορεί να έχουν επίπτωση στα νομικά σας δικαιώματα:
      </Title>
      <Paragraph>
        Κάνοντας χρήση του προϊόντος E-Salvage της VDFM κατανοείτε και
        αποδέχεστε ότι σε οποιοδήποτε πεδίο ελεύθερου κειμένου θα εισάγετε μόνο
        προσωπικά δεδομένα και στο βαθμό που απαιτείται(όπως ορίζεται στον
        κανονισμό (ΕΕ) 2016/679, "ΓΚΠΔ"), καθώς επίσης ότι δεν θα εισαγάγετε
        οποιαδήποτε <strong>Προσωπικά Δεδομένα</strong> σε οποιεσδήποτε από τις
        εικόνες ή τα συννημένα που ενδεχομένως από καιρού εις καιρόν θα
        μεταφορτώνετε στο σύστημα της VDFM.
      </Paragraph>
      {showCheckBox ? (
        <Row justify="space-between">
          <Col xs={12}>
            <Checkbox onChange={handleCheckBoxChange}>
              <span style={{ fontWeight: 600 }}>
                Να μην εμφανιστεί ξανά αυτό το μήνυμα
              </span>
            </Checkbox>
          </Col>
          <Col xs={6}>
            <Button key="submit" type="primary" onClick={handleAccept}>
              Αποδέχομαι
            </Button>
          </Col>
        </Row>
      ) : showApproveButton ? (
        <Row justify="center">
          <Button key="submit" type="primary" onClick={handleAccept}>
            Αποδέχομαι
          </Button>
        </Row>
      ) : null}
    </div>
  );
};

export default VDFMDocument;
